import { getTrustedHTML, SanitizerReturnType } from './getTrustedHTML';

/**
 * Strips HTML tags from a string and returns plain text content.
 * This function safely removes all HTML elements while preserving the text content.
 * Uses getTrustedHTML for secure HTML parsing with Trusted Types support.
 *
 * @param htmlString - The HTML string to strip tags from
 * @returns The plain text content without HTML tags
 */
export function stripHtmlTags(htmlString: string | undefined): string {
    if (!htmlString) {
        return '';
    }

    try {
        // Use getTrustedHTML to safely parse HTML content with Trusted Types support
        const htmlElement = getTrustedHTML(htmlString, SanitizerReturnType.HTMLElement);

        // Extract text content, without any HTML tags
        return htmlElement.textContent || htmlElement.innerText || '';
    } catch {
        return '';
    }
}
